import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-ink-deep text-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="font-serif text-3xl tracking-[0.3em] font-medium">
            GRAT<span className="text-gold">I</span>ORA
          </p>
          <p className="mt-4 text-sm text-cream/60 leading-relaxed max-w-sm">
            The art of bespoke gifting. A Delhi NCR studio crafting corporate hampers,
            wedding favours and signature collections — wrapped with care, made for memories.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow !text-gold/80 mb-5">Explore</p>
          <div className="flex flex-col gap-3 text-sm">
            <Link to="/#story" className="text-cream/70 hover:text-gold transition-colors duration-300">Our Story</Link>
            <Link to="/catalogue" className="text-cream/70 hover:text-gold transition-colors duration-300">Catalogue</Link>
            <Link to="/festive" className="text-cream/70 hover:text-gold transition-colors duration-300">The Festive Edit</Link>
            <Link to="/season/rakhi" className="text-cream/70 hover:text-gold transition-colors duration-300">Rakhi Edit</Link>
            <Link to="/season/new-year" className="text-cream/70 hover:text-gold transition-colors duration-300">New Year Edit</Link>
            <Link to="/#process" className="text-cream/70 hover:text-gold transition-colors duration-300">How Customization Works</Link>
            <Link to="/contact" className="text-cream/70 hover:text-gold transition-colors duration-300">Contact</Link>
          </div>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow !text-gold/80 mb-5">Begin a Brief</p>
          <p className="text-sm text-cream/70">hello@gratiora.in</p>
          <p className="text-sm text-cream/70 mt-1">Delhi NCR, India</p>
          <Link
            to="/enquire"
            className="mt-6 inline-flex items-center gap-2 border border-gold/40 text-gold px-6 py-3 text-sm tracking-wide hover:bg-gold hover:text-ink transition-colors duration-400"
          >
            Request a Quote <ArrowUpRight size={15} />
          </Link>
        </div>
      </div>
      <div className="border-t border-cream/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-cream/40">
          <span>© {new Date().getFullYear()} Gratiora. All rights reserved.</span>
          <span>Handcrafted in Delhi NCR</span>
        </div>
      </div>
    </footer>
  );
}
